import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom"; // Import useNavigate and Link


import { useSelector, useDispatch } from "react-redux"; // Import useSelector and useDispatch
import { fetchIntegrationById } from "@redux/slices/integrationSlice"; // Import the async thunk


import Tabs from "@components/misc/Tabs";
import ConfirmDetails from "./Components/ConfirmDetails";

import tabsList from "@data/editor-tabs.json";

const AddIntegrationSummary = () => {
  const dispatch = useDispatch();
  const integrationDetails = useSelector((state) => state.integration.selectedIntegration);
  const status = useSelector((state) => state.integration.status);

  const { id } = useParams();

  useEffect(() => {
    dispatch(fetchIntegrationById(id));
  }, [dispatch, id]);


  const navigate = useNavigate(); // Get the navigate function

  const handleGotoHome = () => { navigate("/"); }

  const handleGoToDashboard = () => {
    // router.back();
    navigate("/integrations/listing");

  };

  const onTabSelected = (pageName) => {
    navigate(`/integrations/${id}/${pageName.toLowerCase()}`);
  }

  const handleGotoListing = () => {
    //router.push("/add-integration/source-details"); // Navigates to the /about page
    navigate(`/integrations/listing`); // Navigate to the next page
  };

  //   const [activeLink, setActiveLink] = useState(null);
  //   const [scrollActive, setScrollActive] = useState(false);

  // useEffect(() => {
  //   window.addEventListener("scroll", () => {
  //     setScrollActive(window.scrollY > 20);
  //   });
  // }, []);

  return (
    <div className="mx-auto mt-8 sm:mt-12 pt-2 px-4 sm:px-8 lg:px-12 max-w-full">
      <section className="">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
          <div className="flex items-center gap-x-3 w-full lg:w-auto">
            <button
              onClick={handleGotoHome}
              title="Home"
              className="flex items-center justify-center gap-x-2 rounded-full bg-[#f0f7ff] border border-[#cce3ff] px-4 py-2 text-xs sm:text-sm font-bold text-[#1e3a8a] transition-all duration-200 hover:bg-[#e0efff] hover:border-[#b8d9ff] shadow-sm active:scale-95"
            >
              Home
            </button>
            <button
              onClick={handleGoToDashboard}
              title="Dashboard"
              className="flex items-center justify-center gap-x-2 rounded-full bg-[#f0f7ff] border border-[#cce3ff] px-3 py-2 text-[#1e3a8a] transition-all duration-200 hover:bg-[#e0efff] hover:border-[#b8d9ff] shadow-sm active:scale-95"
            >
              <svg className="h-5 w-6" viewBox="0 -4.5 31 31" version="1.1" fill="currentColor">
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round"
                  strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier">
                  <desc>Created with Sketch Beta.</desc> <defs> </defs>
                  <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Icon-Set-Filled"
                      transform="translate(-206.000000, -626.000000)" fill="currentColor">
                      <path d="M235,643 L216,643 C214.896,643 214,643.896 214,645 C214,646.104 214.896,647 216,647 L235,647 C236.104,647 237,646.104 237,645 C237,643.896 236.104,643 235,643 L235,643 Z M235,635 L216,635 C214.896,635 214,635.896 214,637 C214,638.104 214.896,639 216,639 L235,639 C236.104,639 237,638.104 237,637 C237,635.896 236.104,635 235,635 L235,635 Z M216,631 L235,631 C236.104,631 237,630.104 237,629 C237,627.896 236.104,627 235,627 L216,627 C214.896,627 214,627.896 214,629 C214,630.104 214.896,631 216,631 L216,631 Z M209,642 C207.343,642 206,643.343 206,645 C206,646.657 207.343,648 209,648 C210.657,648 212,646.657 212,645 C212,643.343 210.657,642 209,642 L209,642 Z M209,634 C207.343,634 206,635.343 206,637 C206,638.657 207.343,640 209,640 C210.657,640 212,638.657 212,637 C212,635.343 210.657,634 209,634 L209,634 Z M209,626 C207.343,626 206,627.343 206,629 C206,630.657 207.343,632 209,632 C210.657,632 212,630.657 212,629 C212,627.343 210.657,626 209,626 L209,626 Z" id="list" > </path> </g> </g> </g></svg>
            </button>

            <h2 className="flex-1 lg:w-80 text-base sm:text-lg font-bold text-gray-900 uppercase tracking-tight truncate">
              {status === 'loading' ? (
                <div className="my-1 animate-pulse">
                  <div className="h-8 w-40 sm:w-80 rounded-full bg-gray-100">
                  </div>
                </div>
              ) : (
                integrationDetails && integrationDetails.name && integrationDetails.name
              )}
            </h2>
          </div>

          <div className="flex-1 flex items-center justify-center w-full lg:w-auto my-4 lg:my-0 order-3 lg:order-2">
            <div className="w-full lg:w-auto">
              <Tabs tabsList={tabsList} selectedIndex={5} interactive={true} onTabSelected={onTabSelected} />
            </div>
          </div>

          <div className="flex items-center justify-end gap-x-2 sm:gap-x-3 w-full lg:w-auto order-2 lg:order-3">
            <button
              onClick={handleGotoListing}
              className="flex items-center justify-center gap-x-2 rounded-full bg-blue-600 px-5 sm:px-6 py-2 sm:py-2.5 text-xs sm:text-sm font-bold text-white transition-all duration-200 hover:bg-blue-700 shadow-lg hover:shadow-blue-200 active:scale-95"
            >
              Go to All
            </button>
          </div>
        </div>
        <div className="mt-4">
          <ConfirmDetails details={integrationDetails} />
        </div>
      </section>
    </div>
  )
}

export default AddIntegrationSummary;